export default __webpack_public_path__ + "static/media/coal.3656a1f3.svg";